import { createAction, createAsyncAction } from 'typesafe-actions';

export const createSession = createAsyncAction(
  '@ANALYTIC/CREATE_SESSION_REQUEST',
  '@ANALYTIC/CREATE_SESSION_SUCCESS',
  '@ANALYTIC/CREATE_SESSION_FAILURE'
)<string, string, string>();

export const updateSession = createAsyncAction(
  '@ANALYTIC/UPDATE_SESSION_REQUEST',
  '@ANALYTIC/UPDATE_SESSION_SUCCESS',
  '@ANALYTIC/UPDATE_SESSION_FAILURE'
)<undefined, string, string>();

export const navigationUrl = createAsyncAction(
  '@ANALYTIC/NAVIGATION_URL_REQUEST',
  '@ANALYTIC/NAVIGATION_URL_SUCCESS',
  '@ANALYTIC/NAVIGATION_URL_FAILURE'
)<GQL.INavigationInput, GQL.INavigationResponse, string>();

export const negotiation = createAsyncAction(
  '@ANALYTIC/NEGOTIATION_REQUEST',
  '@ANALYTIC/NEGOTIATION_SUCCESS',
  '@ANALYTIC/NEGOTIATION_FAILURE'
)<GQL.IInsertNegotiationModel, string, string>();

export const payment = createAsyncAction(
  '@ANALYTIC/PAGAMENTO_REQUEST',
  '@ANALYTIC/PAGAMENTO_SUCCESS',
  '@ANALYTIC/PAGAMENTO_FAILURE'
)<GQL.IPaymentInput, string, string>();

export const endSession = createAsyncAction(
  '@ANALYTIC/END_SESSION_REQUEST',
  '@ANALYTIC/END_SESSION_SUCCESS',
  '@ANALYTIC/END_SESSION_FAILURE'
)<undefined, string, string>();

export const setErrorAction = createAsyncAction(
  '@ANALYTIC/SETERROR_REQUEST',
  '@ANALYTIC/SETERROR_SUCCESS',
  '@ANALYTIC/SETERROR_FAILURE'
)<GQL.ISetErrorOnMutationArguments, GQL.ISetErrorResponse, string>();

export const setPageView = createAsyncAction(
  '@ANALYTIC/SETPAGEVIEW_REQUEST',
  '@ANALYTIC/SETPAGEVIEW_SUCCESS',
  '@ANALYTIC/SETPAGEVIEW_FAILURE'
)<undefined, string, undefined>();

export const setLogRequestID = createAction('@ANALYTIC/SET_LOGREQUESTID')<
  number | undefined
>();
export const rehydrate = createAction('persist/REHYDRATE')<ApplicationState>();
export const purge = createAction('persist/PURGE')();
